<template>
<div id="saveLoadModal" class="configurator-modal" name="helpModal">
  <div class="configurator-modal-inner">
    <div class="modal-head">
        <i @click="setLoadSaveInvisible()" class="configurator-modal-close-button fal fa-times"></i>
        <h2 class="configurator-modal-headline">
            Konfigurationen speichern und laden  
        </h2>
    </div>
    <div class="configurator-modal-content-wrapper">
        <div class="configurator-modal-inner-content">
            <div id="saveDisclaimer">
                <h4>Speichern</h4>
                <div class="save-modal-element"> 
                    <p class="instruction"> 
                        Mit diesem Code können Sie die Konfiguration wie sie jetzt gerade ist hier abrufen: 
                    </p>
                    <div class="interaction"> 
                        Konfigurationsnummer: 
                        <br> 
                        <p id="configCode">
                            <span>{{ configCodeString }}</span>
                        </p>
                    </div> 
                    <div v-if="p_isConfigurationNameRequired" class="configurator-input-element-wrapper " id="inputElementEmailConfiguration"> 
                        <label class="configurator-input-element-label" for="emailConfigurationName">Konfigurationsname:</label> 
                        <div class="configurator-input-block"> 
                            <input class="configurator-input-element " id="emailConfigurationName" v-model="configurationName" type="text"> 
                        </div> 
                    </div> 
                    <button v-bind:disabled="!this.allowOverwriting && isConfigurationAssigned" class="configurator-button button" v-bind:class="{ 'brand-color': allowOverwriting || !isConfigurationAssigned }"  id="saveConfigurationButton" @click="saveConfiguration()"> 
                        <span class="configurator-button-label">{{ configuratorButtonLabel }}</span> 
                    </button> 
                    <button v-bind:disabled="!isConfigurationAssigned" class="configurator-button button" v-bind:class="{ 'brand-color': isConfigurationAssigned }" id="duplicateConfigurationButton" @click="saveConfiguration(false, true)"> 
                        <span class="configurator-button-label">Konfiguration duplizieren</span> 
                    </button> 
                </div>
            </div>
            <div id="loadDisclaimer"> 
                <h4>Laden</h4>
                <div class="save-modal-element"> 
                    <p class="instruction"> 
                        Sie haben bereits eine Konfigurationsnummer?
                        <br> 
                        Bitte geben Sie ihre zuvor erhaltene Nummer hier ein: 
                    </p> 
                    <div class="interaction"> 
                        Konfigurationsnummer: 
                        <div class="configurator-input-element-wrapper " id="inputElementConfiguration"> 
                            <div class="configurator-input-block"> 
                                <input class="configurator-input-element" v-model="configCode" min="100000" max="999999" id="configurationInput" type="number" data-maxlength="6">
                            </div> 
                        </div> 
                    </div> 
                    <button class="configurator-button button brand-color" id="loadConfigurationButton" @click="loadConfiguration()"> 
                        <span class="configurator-button-label">Konfiguration laden</span> 
                    </button> 
                </div> 
            </div>
            <div id="mailDisclaimer"> 
                <h4>Die Konfiguration und den zugehörigen Code per Mail senden lassen</h4>
                <div id="mailNewsletterContainer"> 
                    <div class="configurator-input-element-wrapper " id="inputElementEmailConfiguration"> 
                        <label class="configurator-input-element-label" for="emailConfigurationInput">E-Mail-Adresse an die Ihre Konfiguration gesendet werden soll:</label> 
                        <div class="configurator-input-block"> 
                            <input class="configurator-input-element " id="emailConfigurationInput" v-model="email" type="email" @keyup="validateEmail()" placeholder="z.B. max@mustermann.de"> 
                        </div> 
                    </div> 
                    <div id="newsletterBox"> 
                        <!--<input type="checkbox" id="newsletterWithConfiguration" name="newsletterWithConfiguration"> 
                        <label for="newsletterWithConfiguration">Erhalten Sie unseren Newsletter mit Infos und exklusiven Rabatten</label> -->
                    </div> 
                </div> 
                <button v-bind:disabled="!isEmailCorrect || !isConfigurationAssigned" class="configurator-button button" v-bind:class="{ 'brand-color': (isEmailCorrect && isConfigurationAssigned) }" @click="sendConfigurationCodeMail()" id="sendConfigurationButton"> 
                    <span class="configurator-button-label">Mail abschicken</span> 
                </button> 
                <br><br> 
                <p id="datenschutz">
                    Mit Klick auf "Mail abschicken" akzeptieren Sie unsere 
                    <a href="" class="brand-color-text" target="_blank">Datenschutzbestimmungen.</a>
                </p> 
                <br> 
            </div>
        </div>
    </div>
  </div>
  <popup v-bind:p_isError="isPopupError" v-bind:p_isWarning="isPopupWarning" v-bind:p_isSuccessful="isPopupSuccessful" v-bind:p_isExecutedOnceIgnored="true" v-bind:p_text="responsePopupText" v-bind:p_header="responsePopupHeader" v-bind:p_isVisible="isResponsePopupVisible" />
</div>
</template>

<script>
import axios from 'axios';
import Popup from './Popup.vue';

const urlCreateSavedConfigurationRest = process.env.URL_BACKEND + process.env.REST_SAVED_CONFIGURATOR_CREATE_SAVED_CONFIGURATION;
const urlUpdateSavedConfigurationRest = process.env.URL_BACKEND + process.env.REST_SAVED_CONFIGURATOR_UPDATE_SAVED_CONFIGURATION;
const urlReadSavedConfigurationRest = process.env.URL_BACKEND + process.env.REST_SAVED_CONFIGURATOR_READ_SAVED_CONFIGURATION;
const urlSendConfigurationCodenRest = process.env.URL_BACKEND + process.env.REST_EMAIL_SEND_CONFIGURATION_CODE;
const noValuesToSaveHeader = 'Speichern fehlgeschlagen';
const noValuesToSaveText = 'Es kann keine leere Konfiguration gepeichert werden.';
const saveSuccessfulHeader = 'Speichern erfolgreich';
const saveSuccessfulText = 'Die Konfiguration wurde erfolgreich gespeichert!';
const saveOverwriteSuccessfulHeader = 'Speichern erfolgreich';
const saveOverwriteSuccessfulText = 'Die Konfiguration wurde erfolgreich überschrieben!';
const loadSuccessfulHeader = 'Laden erfolgreich';
const loadSuccessfulText = 'Die Konfiguration wurde erfolgreich geladen!';
const loadNotSuccessfulHeader = 'Laden fehlgeschlagen';
const loadNotSuccessfulText = 'Die angegebene Konfiguration existiert nicht.';
const overwriteWarningText = "Die angegebene Konfiguration wurde von einem anderen Kunden erstellt. Sie können diese in eine neue Konfiguration duplizieren, um sie zu ändern.";
const overwriteWarningHeader = "Konfiguration von anderem Kunden";
const sendConfigurationMailSuccessfulHeader = 'Email erfolgreich versendet';
const sendConfigurationMailSuccessfulText = 'Die Konfiguration wurde versendet.';

export default {
  components: { Popup },
    props: {
        p_steps: Array,
        p_configuratorId: Number,
        p_price: String,
        p_isOverviewStepAccessible: Boolean,
        p_isConfigurationNameRequired: Boolean,
    },
    data() {
        return {
            savedConfigurationId: -1,
            assignedConfigurationCode: 0,
            configCodeString: 'xxxxxx',
            configCode: 10000,
            email: '',
            configurationName: '',
            configuratorButtonLabel: 'Konfigurationsnr. erstellen',
            isConfigurationAssigned: false,
            isResponsePopupVisible: false,
            isPopupSuccessful: false,
            isPopupError: false,
            isPopupWarning: false,
            isEmailCorrect: false,
            responsePopupText: '',
            allowOverwriting: false,
            responsePopupHeader: '',
            reg: /^(?![\w\.@]*\.\.)(?![\w\.@]*\.@)(?![\w\.]*@\.)\w+[\w\.]*@[\w\.]+\.\w{2,}$/,

        };
    },
    methods: {
        hidePopup() {
            this.isResponsePopupVisible = false;
        },
        setLoadSaveInvisible() {
            this.$parent.setLoadSaveVisibility(false);
        },
        async saveConfiguration(forBasket = false, isDuplicate = false) {
            // Delete Special Steps
            this.$store.commit('deleteSpecificStep',  -2);
            this.$store.commit('deleteSpecificStep',  -1);
            if (this.$store.state.stepValues.length > 0) {
                // Call REST createSavedConfiguration
                if (this.p_isOverviewStepAccessible) {
                    // -1 is used for Overview-Page
                    this.$store.commit('addStepValue', {stepId:-1, stepIndex:-1});
                }
                // // -2 for add Price
                // this.$store.commit('addStepValue', {stepId:-2, stepIndex:-2, price:this.p_price});
                const stepValues = this.$store.state.stepValues;

                let products = "";
                let specialProducts = "";
                if (this.$store.state.products.length > 0) {
                    products = this.$store.state.products;
                }
                if (this.$store.state.specialProducts.length > 0) {
                    specialProducts = this.$store.state.specialProducts;
                }
                if (this.isConfigurationAssigned && !isDuplicate) {
                    const json = JSON.stringify({ affectedSavedConfiguration: {configuration_number: this.assignedConfigurationCode, saved_values: JSON.stringify(stepValues), configurator_id: this.p_configuratorId, products: JSON.stringify(products), special_products: JSON.stringify(specialProducts), configuration_name: this.configurationName }});
                    axios.post(urlUpdateSavedConfigurationRest, json, {
                        headers: {
                        // Overwrite Axios's automatically set Content-Type
                        'Content-Type': 'application/json',
                        },
                    }).then((result) => {
                        result.data.isUpdateConfiguration = true;
                        result.data.configurator_id = this.p_configuratorId;
                        result.data.id = this.savedConfigurationId;
                        let customSaveRespones = this.$parent.$refs.mainComponent.customSaveConfiguration(result.data, true);
                        this.responsePopupText = saveOverwriteSuccessfulText;
                        this.responsePopupHeader = saveOverwriteSuccessfulHeader;
                        this.isResponsePopupVisible = true;
                        this.isPopupSuccessful = true;
                        this.isPopupError = false;
                        this.isPopupWarning = false;
                    });
                }
                else {
                    const json = JSON.stringify({ saved_values: JSON.stringify(stepValues), configurator: { id: this.p_configuratorId }, products: JSON.stringify(products), special_products: JSON.stringify(specialProducts), configuration_name: this.configurationName });
                    
                    if(forBasket) {
                        return axios.post(urlCreateSavedConfigurationRest, json, {
                        headers: {
                        // Overwrite Axios's automatically set Content-Type
                        'Content-Type': 'application/json',
                        },
                        });
                    } else {
                        axios.post(urlCreateSavedConfigurationRest, json, {
                        headers: {
                        // Overwrite Axios's automatically set Content-Type
                        'Content-Type': 'application/json',
                        },
                        }).then((result) => {
                            result.data.isUpdateConfiguration = false;
                            let customSaveRespones = this.$parent.$refs.mainComponent.customSaveConfiguration(result.data, false);
                            this.configuratorButtonLabel = 'Konfiguration überschreiben';
                            this.isConfigurationAssigned = true;
                            this.savedConfigurationId = result.data.id;
                            this.assignedConfigurationCode = result.data.configuration_number;
                            this.configCodeString = ""+result.data.configuration_number;
                            this.responsePopupText = saveSuccessfulText;
                            this.responsePopupHeader = saveSuccessfulHeader;
                            this.isResponsePopupVisible = true;
                            this.isPopupSuccessful = true;
                            this.isPopupError = false;
                            this.isPopupWarning = false;
                            this.$parent.setAllowOverwriting(true);
                            this.allowOverwriting = this.$parent.allowOverwriting;
                        });
                    }
                }
            }
            else {
                this.responsePopupText = noValuesToSaveText;
                this.responsePopupHeader = noValuesToSaveHeader;
                this.isResponsePopupVisible = true;
                this.isPopupSuccessful = false;
                this.isPopupError = true;
                this.isPopupWarning = false;
            }
        },
        async loadConfiguration(getConfigCode = null) {
            // If getConfigCode isn't null a configCode is 
            // send via URL Parameter
            if (getConfigCode != null) {
                this.configCode = parseInt(getConfigCode, 0);
            }
            // Call REST createSavedConfiguration
            const json = JSON.stringify({ affectedSavedConfiguration: { configuration_number: this.configCode, configurator_id: this.p_configuratorId } });
            axios.post(urlReadSavedConfigurationRest, json, {
                headers: {
                // Overwrite Axios's automatically set Content-Type
                'Content-Type': 'application/json',
                },
            }).then(async(result) => {
                // Workaround for the Overview
                // If P is pressed, some elements are missing
                // So the Menu-Button needs to be changed to the
                // mode that includes all
                this.$parent.$refs.topbar.resetMenuItemButton();
                if(result.data.configuration_number != null) {
                    await this.$parent.$refs.mainComponent.customLoadConfiguration(result.data);
                    this.isConfigurationAssigned = true;
                    this.savedConfigurationId = result.data.id;
                    this.assignedConfigurationCode = result.data.configuration_number;
                    this.configCodeString = ""+result.data.configuration_number;
                    this.configuratorButtonLabel = 'Konfiguration überschreiben';
                    this.allowOverwriting = this.$parent.allowOverwriting;
                    this.configurationName = this.allowOverwriting ? result.data.configuration_name : "";
                    let savedValuesJSON = JSON.parse(result.data.saved_values);
                    let savedProductsJSON = JSON.parse(result.data.products);
                    let savedSpecialProductsJSON = JSON.parse(result.data.special_products);
                    this.$store.commit('replaceStepValues', savedValuesJSON);
                    if (savedProductsJSON.length > 0) {
                        this.$store.commit('replaceProducts', savedProductsJSON);
                    } else {
                        this.$store.commit('deleteAllProducts');
                    }
                    if (savedSpecialProductsJSON.length > 0) {
                        this.$store.commit('replaceSpecialProducts', savedSpecialProductsJSON);
                    } else {
                        this.$store.commit('deleteAllSpecialProducts');
                    }
                    this.$parent.loadConfigurationFromVuex();

                    if(!this.allowOverwriting){

                        this.responsePopupText = overwriteWarningText;
                        this.responsePopupHeader = overwriteWarningHeader;
                        this.isResponsePopupVisible = true;
                        this.isPopupSuccessful = false;
                        this.isPopupError = false;
                        this.isPopupWarning = true;

                    } else {
                        this.responsePopupText = loadSuccessfulText;
                        this.responsePopupHeader = loadSuccessfulHeader;
                        this.isResponsePopupVisible = true;
                        this.isPopupSuccessful = true;
                        this.isPopupError = false;
                        this.isPopupWarning = false;

                    }
                }
                else {
                    this.responsePopupText = loadNotSuccessfulText;
                    this.responsePopupHeader = loadNotSuccessfulHeader;
                    this.isResponsePopupVisible = true;
                    this.isPopupSuccessful = false;
                    this.isPopupError = true;
                    this.isPopupWarning = false;
                }
            });
        },
        validateEmail() {
            if (this.reg.test(this.email)) {
                this.isEmailCorrect = true;
            } else {
                this.isEmailCorrect = false;
            }
        },
        async sendConfigurationCodeMail(email = null) {
            let checkCode = 0;
            if(!this.isConfigurationAssigned) {
               let checkCode = await this.saveConfiguration(true);

               this.configuratorButtonLabel = 'Konfiguration überschreiben';
               this.isConfigurationAssigned = true;
               this.assignedConfigurationCode = checkCode.data.configuration_number;
               this.configCodeString = ""+checkCode.data.configuration_number;
               this.responsePopupText = saveSuccessfulText;
               this.responsePopupHeader = saveSuccessfulHeader;
               this.isResponsePopupVisible = true;
               this.isPopupSuccessful = true;
               this.isPopupError = false;
                this.isPopupWarning = false;
            }
            
            let json = JSON.stringify({ affectedSavedConfiguration: { configuration_number: this.assignedConfigurationCode, configurator_id: this.p_configuratorId } });
        
            axios.post(urlReadSavedConfigurationRest, json, {
                headers: {
                // Overwrite Axios's automatically set Content-Type
                'Content-Type': 'application/json',
                },
            }).then((result) => {
                if(result.data.configuration_number != null || email != null) {
                    let signature = "Ihr Duschking-Team";
                    let price = this.p_price;
                    let savedValuesJSON = JSON.parse(result.data.saved_values);
                    if (email != null) {
                        savedValuesJSON = this.$store.state.stepValues;
                    }
                    if (this.$parent.$refs.mainComponent.customeremail != "") {
                        signature = "Ihr "+this.$parent.$refs.mainComponent.customercompany+"-Team";
                    }
                    let savedValuesWithoutSpecial = [];
                    // Go through the steps and search in the saved_values
                    // if a value is saved for that step
                    this.p_steps.forEach( step => {
                        let firstOccurence = true;
                        let tmpSavedValuesJSON = null;
                        // Go through the saved_values
                        for (let i = 0; i < savedValuesJSON.length; ++i) {
                            // The stepId -2 is used for the price
                            // if(savedValuesJSON[i].stepId == -2){
                            //     price = savedValuesJSON[i].price;
                            // } 
                            // If the stepId is the same and if the attribute is not a multiple attribute
                            // like step_skipped
                            // attribute id -10 is pdf
                            if(savedValuesJSON[i].stepId == step.id && (savedValuesJSON[i].attributeVisible && savedValuesJSON[i].attributeId >= 0)) {
                                // If it is the first occurence of the id, the Value should be assigned to 
                                // the temporary variable
                                if (firstOccurence) {
                                    tmpSavedValuesJSON = savedValuesJSON[i];
                                    firstOccurence = false;
                                } 
                                // If it isn't the first occurence, concatenate the valueName with
                                // the new found valueName
                                else {
                                    if (tmpSavedValuesJSON.value == null || tmpSavedValuesJSON.value.length == 0) {
                                        tmpSavedValuesJSON.value = savedValuesJSON[i].value;
                                    }
                                    else {
                                        tmpSavedValuesJSON.value += " "+savedValuesJSON[i].value;
                                    }
                                    tmpSavedValuesJSON.valueName += " "+savedValuesJSON[i].valueName;
                                }
                            }
                            else if (savedValuesJSON[i].stepId == step.id && (savedValuesJSON[i].attributeId == -10 || savedValuesJSON[i].attributeId == -20 || savedValuesJSON[i].attributeId == -21 
                            || savedValuesJSON[i].attributeId == -22 || savedValuesJSON[i].attributeId == -23)) {
                                savedValuesWithoutSpecial.push(savedValuesJSON[i]);
                            }
                        }
                        if (tmpSavedValuesJSON != null) {
                            savedValuesWithoutSpecial.push(tmpSavedValuesJSON);
                        }
                    });
                    let tmpEmail = email == null ? this.email : email;
                    let tmpConfigCode = this.assignedConfigurationCode;
                    let json = JSON.stringify({
                        logo: process.env.URL_BACKEND+"/duschking-konfigurator/config-email-logo.png", 
                        email: tmpEmail, 
                        customer_from_name: this.$parent.$refs.mainComponent.customercompany == "" ? "Duschking" : this.$parent.$refs.mainComponent.customercompany,
                        customer_from_address: this.$parent.$refs.mainComponent.customeremail == "" ? "info@duschking.de" : this.$parent.$refs.mainComponent.customeremail,
                        config_code: tmpConfigCode,
                        price: price,
                        signature: signature, 
                        saved_values: savedValuesWithoutSpecial,
                        configurator_id: this.p_configuratorId,
                    });
                    axios.post(urlSendConfigurationCodenRest, json, {
                        headers: {
                        // Overwrite Axios's automatically set Content-Type
                        'Content-Type': 'application/json',
                        },
                    }).then((result) => {
                        this.responsePopupText = sendConfigurationMailSuccessfulText;
                        this.responsePopupHeader = sendConfigurationMailSuccessfulHeader;
                        this.isResponsePopupVisible = true;
                        this.isPopupSuccessful = true;
                        this.isPopupError = false;
                        this.isPopupWarning = false;
                    });
                }
            });
        },
    },
    
};
</script>

<style language="css">
  @import '../../scss/help/style.css';
  @import '../../scss/load_save/style.css';
</style>


// WEBPACK FOOTER //
// src/components/configurator/LoadSave.vue